/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { adminExternalCredentialsCreateGcpIam } from "../funcs/adminExternalCredentialsCreateGcpIam.js";
import { adminExternalCredentialsDeleteGcpIam } from "../funcs/adminExternalCredentialsDeleteGcpIam.js";
import { adminExternalCredentialsGetGcpIam } from "../funcs/adminExternalCredentialsGetGcpIam.js";
import { adminExternalCredentialsList } from "../funcs/adminExternalCredentialsList.js";
import { adminExternalCredentialsUpdateGcpIam } from "../funcs/adminExternalCredentialsUpdateGcpIam.js";
import { adminExternalCredentialsVerifyGcpIam } from "../funcs/adminExternalCredentialsVerifyGcpIam.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { GcpIamCredential } from "../models/components/gcpiamcredential.js";
import { ListExternalCredentialsResult } from "../models/components/listexternalcredentialsresult.js";
import { VerifyPlatformCredentialResult } from "../models/components/verifyplatformcredentialresult.js";
import {
  CreateGcpIamPlatformCredentialRequest,
  CreateGcpIamPlatformCredentialSecurity,
} from "../models/operations/creategcpiamplatformcredential.js";
import {
  DeleteGcpIamPlatformCredentialRequest,
  DeleteGcpIamPlatformCredentialSecurity,
} from "../models/operations/deletegcpiamplatformcredential.js";
import {
  GetGcpIamPlatformCredentialRequest,
  GetGcpIamPlatformCredentialSecurity,
} from "../models/operations/getgcpiamplatformcredential.js";
import {
  ListPlatformExternalCredentialsRequest,
  ListPlatformExternalCredentialsSecurity,
} from "../models/operations/listplatformexternalcredentials.js";
import {
  UpdateGcpIamPlatformCredentialRequest,
  UpdateGcpIamPlatformCredentialSecurity,
} from "../models/operations/updategcpiamplatformcredential.js";
import {
  VerifyGcpIamPlatformCredentialRequest,
  VerifyGcpIamPlatformCredentialSecurity,
} from "../models/operations/verifygcpiamplatformcredential.js";
import { unwrapAsync } from "../types/fp.js";

export class AdminExternalCredentials extends ClientSDK {
  /**
   * createGcpIamPlatformCredential adminExternalCredentials
   *
   * @remarks
   * Create a platform GCP IAM external credential (organization_id NULL, project_id NULL). Requires platform admin.
   */
  async createGcpIam(
    request: CreateGcpIamPlatformCredentialRequest,
    security?: CreateGcpIamPlatformCredentialSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GcpIamCredential> {
    return unwrapAsync(adminExternalCredentialsCreateGcpIam(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteGcpIamPlatformCredential adminExternalCredentials
   *
   * @remarks
   * Soft-delete a platform GCP IAM external credential by ID. Requires platform admin.
   */
  async deleteGcpIam(
    request: DeleteGcpIamPlatformCredentialRequest,
    security?: DeleteGcpIamPlatformCredentialSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(adminExternalCredentialsDeleteGcpIam(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getGcpIamPlatformCredential adminExternalCredentials
   *
   * @remarks
   * Get a platform GCP IAM external credential by ID. Requires platform admin.
   */
  async getGcpIam(
    request: GetGcpIamPlatformCredentialRequest,
    security?: GetGcpIamPlatformCredentialSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GcpIamCredential> {
    return unwrapAsync(adminExternalCredentialsGetGcpIam(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listPlatformExternalCredentials adminExternalCredentials
   *
   * @remarks
   * List the platform external credentials (provider-independent summary). Optionally filter by provider. Requires platform admin.
   */
  async list(
    request?: ListPlatformExternalCredentialsRequest | undefined,
    security?: ListPlatformExternalCredentialsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListExternalCredentialsResult> {
    return unwrapAsync(adminExternalCredentialsList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateGcpIamPlatformCredential adminExternalCredentials
   *
   * @remarks
   * Replace a platform GCP IAM external credential's configuration. Requires platform admin.
   */
  async updateGcpIam(
    request: UpdateGcpIamPlatformCredentialRequest,
    security?: UpdateGcpIamPlatformCredentialSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GcpIamCredential> {
    return unwrapAsync(adminExternalCredentialsUpdateGcpIam(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * verifyGcpIamPlatformCredential adminExternalCredentials
   *
   * @remarks
   * Run a live 'who am I' probe against a platform GCP IAM credential's resolved identity and report the effective principal. Ephemeral: nothing is persisted. Requires platform admin.
   */
  async verifyGcpIam(
    request: VerifyGcpIamPlatformCredentialRequest,
    security?: VerifyGcpIamPlatformCredentialSecurity | undefined,
    options?: RequestOptions,
  ): Promise<VerifyPlatformCredentialResult> {
    return unwrapAsync(adminExternalCredentialsVerifyGcpIam(
      this,
      request,
      security,
      options,
    ));
  }
}
